import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import CloseRounded from '@mui/icons-material/CloseRounded';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';

const RemoveAsset = ({ asset, handleClose, handleDeleteAsset }) => (
  <Dialog open={Boolean(asset)} onClose={handleClose} fullWidth maxWidth="xs"
    className="wh-dialog wh-dialog--danger"
    aria-labelledby="remove-asset-title">
    {asset && (
      <>
        <div className="wh-dialog-head">
          <div className="wh-dialog-headings">
            <h5 id="remove-asset-title">Remove this asset?</h5>
            <p>{asset.ItemName}</p>
          </div>
          <IconButton className="wh-dialog-close" onClick={handleClose} aria-label="Close">
            <CloseRounded />
          </IconButton>
        </div>

        <DialogContent>
          <div className="wh-warn">
            <WarningAmberRounded />
            <p>
              It will no longer be available to assign to anyone. Assets already issued to
              employees keep their records.
            </p>
          </div>
        </DialogContent>

        <DialogActions>
          <Button variant="contained" color="inherit" onClick={handleClose}>Keep asset</Button>
          <Button variant="contained" color="error" onClick={handleDeleteAsset} autoFocus>Remove</Button>
        </DialogActions>
      </>
    )}
  </Dialog>
);

export default RemoveAsset;
